import { ReactNode } from 'react'
import {
  StyledAppendDotsContainer,
  StyledAppendDotsInner,
  StyledCarousel,
  StyledCustomPaging,
} from '../style'
import { ImageProps } from '../../../types/BannerData'
import { FallbackImage } from '../../UploadImage/fallBack/FallBackImage'
import { QualityMarkProductData } from 'types/ProductData'

interface ProductGalleryProps {
  productImages?: ImageProps[]
  productQualitymarks?: QualityMarkProductData[]
  full?: boolean
  showDots?: boolean
}

export const ProductGallery = ({
  productImages,
  productQualitymarks,
  full,
  showDots = true,
}: ProductGalleryProps) => {
  const customPaging = (i: number) => (
    <StyledCustomPaging className={`custom-dot ${productImages ? 'image-dots' : ''}`}>
      {productImages && productImages[i] ? (
        <FallbackImage
          src={`${productImages[i]?.url_original}`}
          key={i}
          type={'ProductCard'}
          preview={false}
        />
      ) : (
        <FallbackImage
          src={productImages ? `${productImages[i].url_original}` : ''}
          type={'ProductCard'}
          preview={false}
        />
      )}
    </StyledCustomPaging>
  )

  return (
    <StyledCarousel
      rootClassName={full ? 'full' : ''}
      arrows={!!(productImages && productImages.length > 1)}
      dots={!!(showDots && productImages && productImages.length > 1)}
      customPaging={customPaging}
      appendDots={(dots: ReactNode) => (
        <StyledAppendDotsContainer>
          <StyledAppendDotsInner>{dots}</StyledAppendDotsInner>
        </StyledAppendDotsContainer>
      )}
    >
      {productImages &&
        productImages.length > 0 &&
        productImages.map((image, index) => (
          <div key={index} className={'gallery-img-container'}>
            <FallbackImage
              src={`${image.url_original}`}
              type={'ProductCard'}
              preview={false}
            />
            {productQualitymarks && productQualitymarks.length > 0 && (
              <div className="product-qualitymarks">
                {productQualitymarks.map((qmark, index) => (
                  <FallbackImage
                    className="product-qualitymarks-image"
                    src={qmark.quality_mark?.logo ? qmark.quality_mark.logo : ''}
                    type={'notFound'}
                    preview={false}
                    key={index}
                  />
                ))}
              </div>
            )}
          </div>
        ))}
    </StyledCarousel>
  )
}
